module.exports = __webpack_public_path__ + "static/media/04.e0daaf23.png";